// extracted by mini-css-extract-plugin
module.exports = {"products_container":"EshopCard_products_container__asxFg","content_wrapper":"EshopCard_content_wrapper__KURQO","card_wrapper":"EshopCard_card_wrapper__PHDxa"};